<ds-loading *ngIf="loader === true"></ds-loading>
<div class="flex flex-col max-w-240 md:min-w-160">

    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{hdng_nm}} Document</div>
        <button mat-icon-button (click)="Close()" [tabIndex]="-1">
            <mat-icon class="text-current" svgIcon="close"></mat-icon>
        </button>
    </div>
    <!-- overflow-y-auto -->
    <div class="flex flex-col flex-auto p-6 sm:p-8">

        <div fxLayout="row" *ngIf="shwinpt">
            <mat-form-field class="frmfld m-2">
                <mat-label>Select Document Category</mat-label>
                <mat-select  [(ngModel)]="dcmnt_ctgry" placeholder="Select Document Category" (selectionChange)="onCtgryChnge($event.value)">
                    <mat-option *ngFor="let c of dcmntCtgryLst" [value]="c">{{c.dcmnt_ctgry_nm}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div *ngIf="!shwinpt" class="crrd">
            <div class="grid grid-cols-12">
                <div class="col-span-2">
                    <div class="kky">Category</div>

                </div>
                <div class="col-span-1">-</div>
                <div class="col-span-6">
                    <div>{{dcmnt_ctgry_nm}}</div>

                </div>

            </div>
            <div class="grid grid-cols-12">
                <div class="col-span-2">
                    <div class="kky">file path</div>
                </div>
                <div class="col-span-1">-</div>
                <div class="col-span-6">
                    <div>{{fldr_pth}}</div>

                </div>

            </div>

        </div>
        <div fxLayout="row" *ngIf="shwUpld">
            <div class="image__grid">
                <div class="imgUploadDiv" *ngIf="attachments.length < max_mg_ct || !max_mg_ct">
                    <label>
                  <input (change)="handleInputChange($event)" type='file'accept="image/png,image/jpeg,image/jpg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
                  <img src="assets/images/support/img_up_icn.svg" style="cursor: pointer;">
                </label>
                </div>
                <div class="imgUploadDiv" *ngFor="let stgImg of attachments; let k = index">
                  <mat-icon class="RmvBtn" svgIcon="close" (click)="removeImg(stgImg)"></mat-icon>
                  <img *ngIf="stgImg.fl_type == 'image/jpeg' || stgImg.fl_type == 'image/jpg' || stgImg.fl_type == 'image/png' || stgImg.fl_type == 'Image'"  [src]="stgImg.base64">
                  <img *ngIf="stgImg.fl_type == 'application/msword' || stgImg.fl_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || stgImg.fl_type == 'Word'"
                  src="assets/images/support/docx.png" />
                  <img *ngIf="stgImg.fl_type == 'application/vnd.ms-excel' || stgImg.fl_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || stgImg.fl_type == 'Excel'"
                  src="assets/images/support/excel.png" />
                <img *ngIf="stgImg.fl_type == 'application/pdf' || stgImg.fl_type == 'PDF'" src="assets/images/support/pdf.png" />             
                </div>
              </div>
        </div>
        <div class="text-sm font-medium text-red-500 mt-2 mx-2" *ngIf="showNtRegdDiv">
            <fuse-alert [appearance]="'soft'" [name]="'alertBox3'" [type]="'warn'">
                {{err_msg}}
            </fuse-alert>
        </div>
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="-ml-2">
            </div>
            <div class="flex items-center mt-4 sm:mt-0">
                <button class="ml-auto sm:ml-0 m-2" mat-button (click)="Close()">
                    Cancel
                </button>
                <button mat-button [color]="'warn'" [matTooltip]="'Delete'" *ngIf="dialogData.edit_in ==1" (click)="delete()">
                    Delete
                </button>
                <button class="order-first sm:order-last m-2" mat-flat-button [color]="'primary'" (click)="send()">
                    {{sve_btn}}
                </button>
            </div>
        </div>

        <ng-template #deleteDcmntCnfrmDialog>
            <h2 matDialogTitle>Are You Sure Want To Delete This Document?</h2>
            <mat-dialog-actions align="end">
                <button mat-button (click)="closeDialog()">No</button>
                <button mat-button (click)="deleteDcmnt()">Yes</button>
            </mat-dialog-actions>
        </ng-template>
</div>
